import Head from "next/head";
import { GetServerSideProps } from "next";

//local imports
import SeoMetaData from "@/components/utils/seo-metadata";
import fulfillmentPartners from "@/data/fulfillment-partner.json";
import PartnerServiceDetails from "@/components/partners/partner-service-details";

export default function PartnerService({
  fulfillmentPartner,
  partnerServiceDetails,
}: any) {
  return (
    <>
      <Head>
        <title>{partnerServiceDetails.metaData.title}</title>
        <SeoMetaData data={partnerServiceDetails.metaData} />
      </Head>
      {partnerServiceDetails && (
        <PartnerServiceDetails
          servicesDetails={partnerServiceDetails?.details}
          partnerName={fulfillmentPartner?.name}
          logoPath={fulfillmentPartner?.logoPath}
        />
      )}
      ``
    </>
  );
}

// export async function getStaticPaths() {
//   // Generate the paths for each news item
//   const paths = fulfillmentPartners.flatMap((fp) =>
//     fp.serviceCards?.map((service) => ({
//       params: {
//         partner: fp.url,
//         partnerservice: service.link,
//       },
//     }))
//   );

//   return {
//     paths,
//     fallback: true,
//   };
// }

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
  if (!params || !params.partner || !params.partnerservice) {
    return {
      notFound: true,
    };
  }

  const fulfillmentPartner = fulfillmentPartners?.find(
    (t) => t.url === `/${params.partner}`
  );

  if (!fulfillmentPartner) {
    return {
      notFound: true,
    };
  }

  const partnerServiceDetails = fulfillmentPartner.serviceCards?.find(
    (t: any) => t.link === `/${params.partner}/${params.partnerservice}`
  );

  if (!partnerServiceDetails) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      fulfillmentPartner,
      partnerServiceDetails,
    },
  };
};
